import { faCheckCircle, faRotateRight } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect } from "react";
import { IconButton } from "../utils/IconButton";

export function ServiceWorkerInstaller() {
    if (!("serviceWorker" in navigator))
        return null;

    const [state, setState] = React.useState<"checking" | "updateAvailable" | "upToDate">("checking");
    useEffect(() => {
        async function checkServiceWorker() {
            await navigator.serviceWorker.ready;

            const registration = await navigator.serviceWorker.getRegistration();
            if (!registration) return;
            registration?.addEventListener("updatefound", () => {
                setState("updateAvailable");
            });
            if (registration?.waiting || registration?.installing)
                setState("updateAvailable");

            await registration.update();
            if (registration?.waiting || registration?.installing)
                setState("updateAvailable");
            else
                setState("upToDate");
        }

        checkServiceWorker();

    }, []);

    if (state === "checking") {
        return <IconButton
            variant="outline-secondary"
            icon={faRotateRight}
            text="Checking for updates..."
            onClick={() => installServiceWorker(true)}
        />;
    }
    if (state === "updateAvailable") {
        return <IconButton
            variant="success"
            icon={faRotateRight}
            text="Update available"
            onClick={() => installServiceWorker(true)}
        />;
    }


    return <IconButton
        variant="outline-success"
        icon={faCheckCircle}
        text="App is up to date"
        onClick={() => installServiceWorker(true)}
    />;
}

installServiceWorker();

async function installServiceWorker(force?: boolean) {
    if (!("serviceWorker" in navigator)) {
        console.log("Service workers are not supported in this browser.");
        return;
    }

    if (force) {
        const reg = await navigator.serviceWorker.getRegistration();
        console.log("Unregistering existing service worker (force=true)...", reg);
        await reg?.unregister();
    }

    const reg = await navigator.serviceWorker.getRegistration();
    if (reg?.active) {
        console.log("Service worker is already active, skipping installation.");
        return;
    }

    navigator.serviceWorker.register(new URL("../sw.ts", import.meta.url), { type: "module", scope: "/" })
        .then(registration => {
            // TODO: How can we make sure that the service worker is actually used?
            console.log("Service worker registered:", registration);
            if (force) {
                if (registration.installing) {
                    const newServiceWorker = registration.installing!;
                    newServiceWorker.addEventListener("statechange", () => {
                        console.log(newServiceWorker.state);
                        navigator.serviceWorker.addEventListener("message", event => {
                            if (event.data === "IS_ACTIVATED") {
                                console.log("New service worker is activated and controlling the page.");
                                window.location.reload();
                            }
                        });
                        const backChannel = new MessageChannel();
                        backChannel.port2.onmessage = event => {
                            console.log("New service worker is activated and controlling the page.", event.data);
                            window.location.reload();
                        };
                        newServiceWorker.postMessage({ type: "SKIP_WAITING", backChannel: backChannel.port1 }, [backChannel.port1]);
                    });
                } else if (registration.waiting) {
                    const backChannel = new MessageChannel();
                    backChannel.port2.onmessage = event => {
                        console.log("New service worker is activated and controlling the page.", event.data);
                        window.location.reload();
                    };
                    console.log("Sending SKIP_WAITING message to waiting service worker to activate it immediately.");
                    registration.waiting.postMessage({ type: "SKIP_WAITING", backChannel: backChannel.port1 }, [backChannel.port1]);
                }
            }
            console.log("Service worker installed successfully (sw.ts).");
        })
        .catch(error => {
            console.error("Service worker registration failed:", error);
            console.log("Failed to install service worker.");
        });
}
